import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { CommunityMember } from "@/react/types/CommunityMember";
import { Icon } from "../../../Icon";
import { Button } from "../../../uikit/Button";
import { Typography } from "../../../uikit/Typography";
import { useSendMessageToUser } from "../../hooks/useSendMessageToUser";

export const MessageButton = ({
  shouldShowOnlyIcon = false,
  member,
}: {
  member: CommunityMember;
  shouldShowOnlyIcon?: boolean;
}) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const { handleMessageMember, isLoading } = useSendMessageToUser();

  return (
    <Button
      variant="secondary"
      onClick={async event => {
        event.preventDefault();
        event.stopPropagation();
        isViewOnlyMasquerading
          ? noop
          : await handleMessageMember(member.id.toString());
      }}
      aria-label={t("message")}
      data-testid="chat-button"
      large
      className={classNames(
        "!border-primary !h-8 w-full gap-2 !px-4 !font-medium",
        shouldShowOnlyIcon && "!w-8 !p-1.5",
      )}
      disabled={isLoading}
    >
      {isLoading ? (
        <Icon type="loader" viewBox="0 0 16 16" />
      ) : (
        <>
          <Icon type="16-bubble-annotation" size={16} useWithFillCurrentColor />
          {!shouldShowOnlyIcon && (
            <Typography.LabelSm color="text-primary" weight="font-medium">
              {t("message")}
            </Typography.LabelSm>
          )}
        </>
      )}
    </Button>
  );
};
